export var defaultTheme = {
    fontFamily: 'Inter, sans-serif',
    color: {
        primary: '#00BBFF',
        secondary: '#EFEEFF',
        danger: '#FF0000',
        background: '#F1EFEE',
        accent: '#26BBF1',
        success: '#2DAD35',
        modalBg: '#FFFFFF',
    },
    modalBorderRadius: {
        borderRadius: '1px',
    },
    typography: {
        heading: {
            fontSize: '18px',
            fontWeight: '600',
            color: '#111A45',
        },
        subHeading: {
            fontSize: '16px',
            fontWeight: '400',
            color: '#111A45',
        },
        labels: {
            fontSize: '14px',
            fontWeight: '400',
            color: '#8E95AA',
        },
        authLabel: {
            fontSize: '16px',
            fontWeight: '600',
            color: '#000000',
            borderRadius: '20px',
        },
    },
};
export var fontFamily = [
    'Arial',
    'Helvetica',
    'Times New Roman',
    'Georgia',
    'Verdana',
    'Courier New',
    'Tahoma',
    'Trebuchet MS',
    'Lucida Sans Unicode',
    'Palatino Linotype',
    'Garamond',
    'Comic Sans MS',
    'Impact',
    'Segoe UI',
    'Franklin Gothic Medium',
    'Gill Sans',
    'Century Gothic',
    'Monaco',
    'Arial Black',
    'Candara',
    'Popins',
];
export var fontWeight = [
    { label: 'Thin', value: '100' },
    { label: 'Extra Light', value: '200' },
    { label: 'Light', value: '300' },
    { label: 'Normal', value: '400' },
    { label: 'Medium', value: '500' },
    { label: 'Semi Bold', value: '600' },
    { label: 'Bold', value: '700' },
    { label: 'Extra Bold', value: '800' },
    { label: 'Black', value: '900' },
];
